export default class LogoutOptions {
  public isForced = false
  public isRemoveTokenFromCookie = false

  public constructor(fields?: {
    isForced?: boolean,
    isRemoveTokenFromCookie?: boolean,
  }) {
    if (fields) {
      Object.assign(this, fields)
    }
  }
}
